import { render } from "./Dosage.vue?vue&type=template&id=ac683f96"
import script from "./Dosage.vue?vue&type=script&lang=js"
export * from "./Dosage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pharmarcy/Dosage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac683f96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac683f96', __exports__)) {
    api.reload('ac683f96', __exports__)
  }
  
  module.hot.accept("./Dosage.vue?vue&type=template&id=ac683f96", () => {
    api.rerender('ac683f96', render)
  })

}


export default __exports__